import React from 'react';
import { getSettings } from '../util/getSettings';

const FilterButton = ({ label, onClick, active, ariaExpanded, ariaControl }) => {
  const labels = getSettings(['century', 'labels'], true);

  return (
    <button
      className={active ? 'filter-button active' : 'filter-button'}
      onClick={onClick}
      aria-expanded={ariaExpanded}
      aria-controls={ariaControl}
    >
      {label !== '' ? <div className="label">{label}</div> : null}
      <span className="filter-button_symbol fas fa-angle-down" aria-hidden="true"></span>
    </button>
  );
};

export default FilterButton;
